import { customEvent, generateLeadEvent } from '../../../modules/tracking/AnalyticsEvents';
import { PostcodeLookup } from '../../../validation/PostcodeLookup';

export default async function() {
    const form = document.getElementById('find-car-form');
    if (!form) {
        console.error('new-car-pages/modules/young-drivers/find-car-form.js No valid form found');
        return;
    }

    // Try to get the ID of the form, and if we can't, generate one
    let formID = form.getAttribute('id');
    if (!formID) {
        form.setAttribute('id', 'campaign-form-' + Math.floor(Date.now()));
    }

    // Find a car
    const brandInputs = form.querySelectorAll('#tab-brand input[name=brand]');
    let brand = '';
    let alreadyChecked = form.querySelector('#tab-brand input[name=brand]:checked');
    if (alreadyChecked) {
        brand = alreadyChecked.value;
    }

    function updateMileages() {
        let mileages = brand == 'peugeot' ? [ '', 6667, 8333, 10000, 11667, 13333, 15000, 16667, 18333, 20000 ] : [ '', 6000, 8000, 10000, 12000, 15000, 20000, 25000, 30000 ];

        document.querySelector('#tab-deposit select[name=mileage]').innerHTML = mileages.map(mileage => `<option value="${mileage}">${mileage}</option>`);
    }

    updateMileages();

    function updateModels() {
        $('#tab-model .option').hide();
        if (brand !== '') {
            $('#tab-model .option.' + brand).show();
        }
    }

    updateModels();

    brandInputs.forEach(element => {
        element.addEventListener('change', function() {
            brand = $(this).val();

            customEvent('Young Drivers', 'Brand Selected', brand);
            locationHandler.updateBrand(brand);

            $('.find-car input[name=finance]').val(brand == 'peugeot' ? 'JAFPCP_TELEMATICS' : 'SIMPLYDRIVE_TELEMATICS');

            updateMileages();

            $('#tab-model input[name="model[]"]').prop('checked', false).trigger('change');

            updateModels();
        });
    });

    const dealers = await window.LocationDataLoader.get();

    const locationHandler = new PostcodeLookup({
        dealers: dealers,
        target: '#find-car-form',
        onUpdate: function(data) {
            locationHandler.sortDealersWithLatLng(function (nearestDealers) {
                for (let k in nearestDealers) {
                    $('input[name=location-id]').val(nearestDealers[k].id);
                    break;
                }
            });
        },
        onSortDealers: function (nearestDealers) {
            for (let k in nearestDealers) {
                $('input[name=location-id]').val(nearestDealers[k].id);
                break;
            }
        },
        filters: {
            brand: 'ds',
            new: true,
        }
    });

    // Prepopulate on page load if we can
    if (brand) {
        locationHandler.updateBrand(brand);
    }

    document.querySelectorAll('.footer-btn.next').forEach(nextButton => {
        nextButton.addEventListener('click', async function(e) {
            e.preventDefault();

            let valid = true;

            const youngDriverValidator = new ContactFormValidator({ target: '#find-car-form' });
            youngDriverValidator.validateSelector('.find-car .tab-pane[aria-expanded="true"]');

            document.querySelectorAll('.find-car .tab-pane[aria-expanded="true"] input').forEach(element => {
                if (!element.checkValidity()) {
                    valid = false;
                }
            });

            if (!await youngDriverValidator.isValid()) {
                $('.find-car .tab-pane[aria-expanded="true"]').parent().removeClass('find-car__step--completed')
                return false;
            }

            if (valid) {
                if ($('.find-car #tab-details').attr('aria-expanded') === 'true') {
                    // $('#find-car-form').submit();
                } else {

                    $(this)
                        .closest('.find-car__step')
                        .addClass('find-car__step--completed')
                        .next('.find-car__step')
                        .removeClass('pointer-events-none')
                        .find('.collapse')
                        .collapse('show')

                    customEvent('Young Drivers', $('.find-car .tab-pane[aria-expanded="true"]').prev().find('a').text(), 'Clicked');
                }
            } else {
                alert('Please ensure all fields are filled in.');
            }
        });
    });

    form.addEventListener('submit', async function(e) {
        e.preventDefault();

        const validator = new ContactFormValidator({element: form});
        if (!await validator.isValid()) {
            return;
        }

        const formData = new FormData(form);
        validator.preventInput();

        $.ajax({
            type: "POST",
            cache: false,
            processData: false,
            contentType: false,
            url: form.getAttribute('action'),
            data: formData,
            success: function(response) {
                customEvent('Young Drivers', 'Find A Car', 'Complete');
                generateLeadEvent('young_drivers_find_a_car');

                if (response.url) {
                    validator.allowInput();
                    window.location.replace(response.url);
                } else {
                    validator.errorResponse(response);
                }
            },
            error: function(response) {
                validator.errorResponse(response);
            }
        });
        return false;
    });
}